// extracted by mini-css-extract-plugin
export default {"collaboratorContainer":"CollaboratorsList_collaboratorContainer__K3-Sa"};